import { render, staticRenderFns } from "./LKPublicationsDataCollection.vue?vue&type=template&id=47cc537c&"
import script from "./LKPublicationsDataCollection.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsDataCollection.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsDataCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports